// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA_B3KLS1Oy5P0xa69VEEKGu67Vm-lu-IU",
  authDomain: "api-project-735688423066.firebaseapp.com",
  databaseURL: "https://api-project-735688423066.firebaseio.com",
  projectId: "api-project-735688423066",
  storageBucket: "api-project-735688423066.appspot.com",
  messagingSenderId: "735688423066",
  appId: "1:735688423066:web:b8141d182454ef626c5123",
  measurementId: "G-GDKBQ7QTW4",
};

// Initialize Firebase
let analytics;
const app = initializeApp(firebaseConfig);
if (app.name && typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { app, analytics };
